import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import programs from '../programs.json';
import { loadState, saveState } from '../utils/localStorage';

const LevelsView = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const state = loadState() || {
    totalPushups: 0,
    userProgress: { currentLevelId: programs[0].id, currentSetIndex: 0 },
    settings: { soundEnabled: true }
  };

  function selectLevel(id) {
    const newState = {
      ...state,
      userProgress: { currentLevelId: id, currentSetIndex: 0 }
    };
    saveState(newState);
    navigate('/');
  }

  return (
    <div style={{ paddingBottom: 60 }}>
      <h2>{t('levels')}</h2>
      <div>
        {programs.map(p => (
          <div key={p.id} style={{ border: '1px solid #ccc', borderRadius: 8, margin: '1rem 0', padding: '1rem', cursor: 'pointer' }} onClick={() => selectLevel(p.id)}>
            <div style={{ fontWeight: 'bold', fontSize: 18 }}>{p.name}</div>
            <div>{t('sets')}: {p.reps.join('-')}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LevelsView;